import restUtils from "core/utils/rest";
import {
  InvestorAmlHistoryItem,
  amlReviewListTransformer,
  ReviewListResponse,
  investorAmlDetailTransformer,
  investorAmlHistoryTransformer,
  AssignRequestPayload,
  StatusUpdatePayload,
  SubCustomerResponse,
  TimeLineTransformer,
} from "./transformers/aml";
import { AmlStatusEnum, UpliftStatusEnum } from "../model";
import { ConcessionStatus, OnboardingModelName } from "../constant/amlConstant";

export type GetReviewListParams = {
  accountId?: string;
  personId?: string;
  pepStatus?: string;
  status?: string;
  riskStatus?: string;
  sancStatus?: string;
  idvStatus?: string;
  onboardingModel?: string;
  skip: string,
  limit: string,
}

export type GetInvestorAmlSubjectResponse = {
    date: number;
    identifier: string;
    uplift?: {
      upliftStatus: UpliftStatusEnum;
      plannedDate: string
    };
    kycDetailsStatus: number;
    entityType: string;
    type: string;
    expiryDate: number;
    name: string;
    onboarding: {
      date: number;
      accountId: string;
      model: keyof typeof OnboardingModelName;
    };
    lastVerificationDate: number;
    concessionStatus: keyof typeof ConcessionStatus;
    status: AmlStatusEnum;
    customer: {
      name: string;
      id: string;
    };
    businessChannel?: string;
  }

export const getReviewList = (params: GetReviewListParams) => {
  return restUtils.call<ReviewListResponse>("PortalApi", "hubwise-api/aml/review-list", "GET", {
    ...params,
    fromAdmin: true,
  }).then((response) => {
    return amlReviewListTransformer(response);
  });
};

export const getInvestorAmlDetail = (investorId: string) => {
  const url = "hubwise-api/aml/timeline-detail";
  const params = {
    personId: investorId,
  };
  return restUtils.call("PortalApi", url, "GET", params).then((response: any) => {
    return investorAmlDetailTransformer(response.payload);
  });
};

export const getTimeLine = (investorId: string) => {
  const url = "hubwise-api/aml/timeline";
  const params = {
    personId: investorId,
  };
  return restUtils
    .call("PortalApi", url, "GET", params)
    .then((response: any) => {
      return response.rows.map(TimeLineTransformer);
    });
};

export const getInvestorAmlHistory = (investorId: string): Promise<InvestorAmlHistoryItem[]> => {
  const url = `hubwise-api/ims/investor/${investorId}/aml`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map(investorAmlHistoryTransformer);
  });
};

export const assignToMe = (investorId: string, payload: AssignRequestPayload) => {
  const url = `hubwise-api/aml/${investorId}/assigned`;
  return restUtils.call("PortalApi", url, "POST", payload);
};

export const updateStatus = (investorId: string, payload: StatusUpdatePayload) => {
  const url = `hubwise-api/aml/${investorId}/results`;
  return restUtils.call("PortalApi", url, "PUT", payload);
};

export const getSubCustomers = () => {
  return restUtils.call<SubCustomerResponse>("PortalApi", "hubwise-api/system/sub-customers", "GET").then((response) => {
    return response.payload;
  });
};

export const getInvestorAmlSubject = (investorId: string) => {
  const url = `hubwise-api/aml/subject/${investorId}`;
  return restUtils.call<GetInvestorAmlSubjectResponse>("PortalApi", url, "GET").then((response) => {
    return response;
  });
};

